<app-gmao-spinner *ngIf="!incidents"></app-gmao-spinner>
<ng-container *ngIf="!btnClicked && incidents">
    <div class="view-item">
        <a routerLink="/incidents-list">Voir toutes les pannes non traitées</a>
    </div>
    <br><br>
    <mat-table [dataSource]="sortedData" matSort (matSortChange)="sortData($event)">
        <ng-container matColumnDef="numSerie" >
            <mat-header-cell *matHeaderCellDef mat-sort-header="numero_serie"> S/N </mat-header-cell>
            <mat-cell *matCellDef="let incident">{{ incident.numero_serie}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="nomInstallation">
            <mat-header-cell *matHeaderCellDef mat-sort-header="nom_installation"> Nom </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{ incident.nom_installation}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="suiviMotif">
            <mat-header-cell *matHeaderCellDef mat-sort-header="suivi_motif"> Motif du suivi </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{ incident.suivi_motif}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="suiviJoursRestants">
            <mat-header-cell *matHeaderCellDef mat-sort-header="suivi_jours_restants"> Suivi restant </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{ incident.suivi_jours_restants}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rgCount">
            <mat-header-cell *matHeaderCellDef mat-sort-header="rg_count"> Pannes </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{ incident.rg_count}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="erCount">
            <mat-header-cell *matHeaderCellDef mat-sort-header="er_count"> RE </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{ incident.er_count}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="anomalies">
            <mat-header-cell *matHeaderCellDef mat-sort-header="anomalies_count"> Anomalies </mat-header-cell>
            <mat-cell *matCellDef="let incident"> {{incident.anomalies_count}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: ['numSerie', 'nomInstallation', 'suiviMotif', 'suiviJoursRestants', 'rgCount', 'erCount', 'anomalies'] ;"
            (click)="getOneMachinePannesData(row.id_installation_suivi)"
            [ngClass]="{'red' : row.suivi_importance == 2, 'orange' : row.suivi_importance == 1}"></mat-row>
    </mat-table>
</ng-container>